export default __webpack_public_path__ + "static/media/download_page_phone_item_laos.c75a765d.png";